import { Box, Flex, StackDivider, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { SourcingEventDto } from "../../../../../../autogen/bff-api";
import { TipTap, isTiptapContentEmpty } from "../../../../../../common/input/TipTap/TipTap";
import type { PublicEventStep } from "../../wizardSteps";
import { MinimumRequirementResponseTypeBadge } from "../MinimumRequirementResponseTypeBadge";
import { EmptyValue } from "./SummaryField";
import { SummarySection } from "./SummarySection";

interface MinimumRequirementsSectionProps {
  event: SourcingEventDto;
  onWizardStepNavigate: (step: PublicEventStep) => void;
}

export const MinimumRequirementsSection = ({
  event,
  onWizardStepNavigate,
}: MinimumRequirementsSectionProps) => {
  const { t } = useTranslation();
  const requirements = event.eventData.minimumRequirements ?? [];

  return (
    <SummarySection
      title={t("Minimum requirements")}
      editTarget={{ kind: "wizard-step", step: "minimumRequirements" }}
      fieldStatuses={[]}
      onWizardStepNavigate={onWizardStepNavigate}
    >
      {requirements.length === 0 ? (
        <EmptyValue text={t("No minimum requirements")} />
      ) : (
        <VStack spacing="4" align="stretch" divider={<StackDivider borderColor="smBorder" />}>
          {requirements.map((requirement, i) => (
            <Flex
              key={requirement.id ?? i}
              direction={{ base: "column", md: "row" }}
              gap={{ base: "2", md: "6" }}
              align="start"
            >
              <Box flexShrink={0} w={{ base: "auto", md: "210px" }}>
                <MinimumRequirementResponseTypeBadge responseType={requirement.responseType} />
              </Box>
              <Box flex="1" minW="0">
                <Text fontWeight="semibold">
                  {requirement.title || <EmptyValue text={t("Untitled")} />}
                </Text>
                {!isTiptapContentEmpty(requirement.description) && (
                  <Box mt="1" fontSize="sm" color="smMuted">
                    <TipTap content={requirement.description} editable={false} hasBorder={false} padding="0" maxHeight="" />
                  </Box>
                )}
              </Box>
            </Flex>
          ))}
        </VStack>
      )}
    </SummarySection>
  );
};
